import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import { useBreakpoint } from '../../../../../components/misc/Breakpoints/Breakpoints';
import LocalTexts from '../ulezText.json';

import {
  BLUE,
  GREEN,
  ORANGE,
} from './helpers';

import styles from './Map.scss';

const LocalT = new MDText(LocalTexts);

const MAP_LEGEND_OPACITY = '.6';

const LEGEND_DATA = [
  {
    color: ORANGE,
    id: 1,
    opacity: MAP_LEGEND_OPACITY,
    subtitle: LocalT.translate('mapLegend.subtitle1'),
    title: LocalT.translate('mapLegend.title1'),
  },
  {
    color: BLUE,
    id: 2,
    opacity: MAP_LEGEND_OPACITY,
    subtitle: LocalT.translate('mapLegend.subtitle2'),
    title: LocalT.translate('mapLegend.title2'),
  },
  {
    color: GREEN,
    id: 3,
    opacity: MAP_LEGEND_OPACITY,
    subtitle: LocalT.translate('mapLegend.subtitle3'),
    title: LocalT.translate('mapLegend.title3'),
  },
];

type MapLegendProps = {
  expandedMap?: boolean;
  onClick: () => void;
}

export const MapLegend = ({ expandedMap, onClick }: MapLegendProps) => {
  const breakpoints = useBreakpoint();
  const { breakpointMobile, breakpointTablet } = breakpoints.maxWidth;

  return (
    <ComponentContent className='' maxWidth={CONTENT_SIZES.container}>
      <div className={cx(styles.legend, { [styles.expandedMap]: expandedMap })}>
        <ul>
          {LEGEND_DATA.map(({
            color,
            id,
            opacity,
            subtitle,
            title,
          }) => (
            <li key={id}>
              <span style={{ backgroundColor: color, opacity }} />
              <div>
                <h6>{title}</h6>
                <p className={styles.subtitle}>{subtitle}</p>
              </div>
            </li>
          ))}
        </ul>
        {(breakpointMobile || breakpointTablet) && !expandedMap && (
          <button className="mw-button mw-button-secondary" onClick={onClick} type="button">
            {LocalT.translate('mapLegend.fullScreen')}
          </button>
        )}
      </div>
    </ComponentContent>
  );
};
